import Vue from 'vue'
// muse-ui
import '@/plugin/muse-ui'
// fontawesome
import '@/plugin/fontawesome'
// styles
import 'material-design-icons/iconfont/material-icons.css'
import 'typeface-roboto'

// rssant
import App from './App'
import router from '@/router'
import { pageMixin } from '@/store/page'
import { LAYOUT } from '@/plugin/common'
import '@/styles/theme-rssant.less'
import '@/plugin/theme'

// REM layout
import initREM from '@/plugin/rem'

initREM(true, 32, 1)

Vue.config.productionTip = false

Vue.prototype.$LAYOUT = LAYOUT
Vue.mixin(pageMixin)

window.app = new Vue({
  el: '#app',
  router,
  render: h => h(App),
})

// remove spinner: https://pathgather.github.io/please-wait/
document.addEventListener('DOMContentLoaded', function() {
  let spiner = document.getElementById('rssant-spinner')
  if (spiner !== undefined && spiner !== null) {
    spiner.remove()
  }
  let darkModeStyle = document.getElementById('rssant-dark-mode-style')
  if (darkModeStyle !== undefined && darkModeStyle !== null) {
    darkModeStyle.remove()
  }
})
